if (!customElements.get(`product-info`)) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.isEnabledStickyContent = this.dataset.enabledStickyContent === 'true';
      // Bound handlers stored for removeEventListener in disconnectedCallback.
      this._boundSetStickyHeight = this.setStickyHeight.bind(this);
      this._boundSectionLoad = (event) => {
        if (!event.target.classList.contains('section-product-details') && !event.target.classList.contains('section-main-product')) return;
        this.setStickyHeight();
      };
      this._boundSectionReorder = () => { this.setStickyHeight(); };
    }

    connectedCallback() {
      if (this.isEnabledStickyContent) {
        this.setStickyHeight();
        window.addEventListener('resize', this._boundSetStickyHeight);
        document.addEventListener(`${PRODUCT_EVENT.updatedVariant}${this.sectionId}`, this._boundSetStickyHeight);
        if (Shopify.designMode) {
          document.addEventListener("shopify:section:load", this._boundSectionLoad);
          document.addEventListener("shopify:section:reorder", this._boundSectionReorder);
        }
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._boundSetStickyHeight);
      document.removeEventListener(`${PRODUCT_EVENT.updatedVariant}${this.sectionId}`, this._boundSetStickyHeight);
      if (Shopify.designMode) {
        document.removeEventListener("shopify:section:load", this._boundSectionLoad);
        document.removeEventListener("shopify:section:reorder", this._boundSectionReorder);
      }
    }

    setStickyHeight() {
      const contentSideEle = this.querySelector(`.product-template__content-wrapper[data-section-id="${this.sectionId}"]`);
      if (window.innerWidth >= MIN_DEVICE_WIDTH.tablet) {
        requestAnimationFrame(() => {
          let totalHeightMediaSide = 0;
          let totalHeightContentSide = 0;
          document.querySelectorAll(`.product-template__media-wrapper[data-section-id="${this.sectionId}"], .section-main-product + .section-product-details product-details`).forEach((elem) => {
            totalHeightMediaSide += elem.getBoundingClientRect().height;
          });
          const contentSideEle = this.querySelector(`.product-template__content-wrapper[data-section-id="${this.sectionId}"]`)
  
          this.querySelectorAll(`.product-template__content-wrapper[data-section-id="${this.sectionId}"]`).forEach((elem) => {
            totalHeightContentSide += elem.getBoundingClientRect().height;
          });
  
          const contentSideContainerEle = contentSideEle.querySelector(`.product-template__content__container`);
          contentSideEle.style.minHeight = `${totalHeightMediaSide}px`;
          if (totalHeightMediaSide >= contentSideEle.getBoundingClientRect().height) {
            if (contentSideContainerEle) {
              contentSideContainerEle.classList.add(`md:sticky`);
            }
          } else {
            if (contentSideContainerEle) {
              contentSideContainerEle.classList.remove(`md:sticky`);
            }
          }
        })
      } else {
        contentSideEle.style.minHeight = 'auto';
      }
    }
  }

  customElements.define(`product-info`, ProductInfo);
}